"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.IconSizes = void 0;
var AndroidBadgeIcon_1 = require("./AndroidBadgeIcon");
__createBinding(exports, AndroidBadgeIcon_1, "default", "AndroidBadgeIcon");
var AppleBadgeIcon_1 = require("./AppleBadgeIcon");
__createBinding(exports, AppleBadgeIcon_1, "default", "AppleBadgeIcon");
var OpenSignIcon_1 = require("./OpenSignIcon");
__createBinding(exports, OpenSignIcon_1, "default", "OpenSignIcon");
var IconSizes;
(function (IconSizes) {
    IconSizes[IconSizes["TINY"] = 12] = "TINY";
    IconSizes[IconSizes["SMALL"] = 16] = "SMALL";
    IconSizes[IconSizes["MEDIUM"] = 24] = "MEDIUM";
    IconSizes[IconSizes["LARGE"] = 32] = "LARGE";
    IconSizes[IconSizes["X_LARGE"] = 48] = "X_LARGE";
    IconSizes[IconSizes["XX_LARGE"] = 64] = "XX_LARGE";
    IconSizes[IconSizes["XXX_LARGE"] = 96] = "XXX_LARGE";
    IconSizes[IconSizes["HUGE"] = 128] = "HUGE";
})(IconSizes = exports.IconSizes || (exports.IconSizes = {}));
